import { Injectable } from '@angular/core';
import { DaComponent } from "./ad/da.component";
import { Observable } from "rxjs/internal/Observable";
import { delay, tap } from "rxjs/operators";
import { of } from "rxjs/internal/observable/of";

@Injectable()
export class DasService {

  private currentAdComponent: DaComponent;

  public delayBeforeOpeningAd = 10000;

  constructor() { }

  setCurrentAdComponentObs(daComponent: DaComponent): Observable<boolean> {
    if (!!this.currentAdComponent) {
      this.currentAdComponent.close();
    }
    return of(true).pipe(
      delay(!!this.currentAdComponent ? this.delayBeforeOpeningAd : 0),
      tap(() => this.currentAdComponent = daComponent),
    );

  }
}
